export const getPhotos = (photoId, setPath) => {
	const photoPaths = photoId
		? photoId.includes(',')
			? photoId.split(',')
			: [photoId]
		: []

	const initialPath = photoPaths?.map((path) => ({
		file: 'not empty',
		has: true,
		path,
		imgLoading: false,
	}))

	const finalPath =
		initialPath.length > 0
			? initialPath
			: [{ file: null, path: '', imgLoading: false }]

	setPath(finalPath)
}
